import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';

import Checkbox from '../../../../../components/Elements/Checkbox';

import './styles.scss';

export default (props) => {
  const dropdownIcon =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAADaADAAQAAAABAAAACAAAAABC4rXkAAAArElEQVQYGXWPsQ3CMBBF/0VAnU3ICDAJATEApkQUpkjtCVCUCWCDMAJsQh/w4XMEmOi4wvKd3/O3qXJ1wfCLB7KDNcs7/lTKZWAuCbQZg1vr6lxzeoFb4SZ4zrKOyDLzLcCFJn4F5MxodmZ9JrlZEkbsL0Q0De21A83lqUNhv12VwkdJNkPRgwyBTwGICW/hR1JEGYUvo0kFmX2SpJFKEzWhp5RVxModrXIURy9zcGGo5HOY0gAAAABJRU5ErkJggg==';

  const {
    className,
    label,
    value,
    onChange,
    placeholder,
    dropdownItemsList,
    dropdownItemsChecked,
    useCheckbox,
    styleWidth,
    frozenValue,
    darkMode,
    disabled,
    messageNoItems,
    useSearch,
  } = props;

  const [stateValue, setStateValue] = useState(value || '');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [itemsChecked, setItemsChecked] = useState(dropdownItemsChecked || []);
  const [filteredDropdownItemsList, setFilteredDropdownItemsList] = useState(
    dropdownItemsList || []
  );

  const selectMod = useRef(null);

  const dropdownItems = dropdownItemsList || [];

  useEffect(() => {
    document.addEventListener('click', removeModSelect, false);
    return () => {
      document.removeEventListener('click', removeModSelect, false);
    };
  }, []);

  useEffect(() => {
    if (dropdownItemsChecked && dropdownItemsChecked.length === 0) {
      setStateValue(value || '');
    } else if (dropdownItemsChecked) {
      const newValue = dropdownItemsChecked
        .map((i) => {
          const item = dropdownItems.find((ii) => (ii.id || ii._id) === i);
          return item.name;
        })
        .join(', ');
      if (!frozenValue) {
        setStateValue(newValue);
      }
    }
    setItemsChecked(dropdownItemsChecked || []);
  }, [dropdownItemsChecked]);

  useEffect(() => {
    if (value === '') {
      if (!useSearch) {
        setStateValue('');
      }
    } else {
      setStateValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (useSearch) {
      if (!stateValue || stateValue === '') {
        setFilteredDropdownItemsList(dropdownItems);
      } else if (dropdownOpen) {
        const items = dropdownItemsList.filter(
          ({ name }) =>
            name.toLowerCase().indexOf(stateValue.toLowerCase()) !== -1
        );
        setFilteredDropdownItemsList(items);
      }
    }
  }, [dropdownItemsList, stateValue, dropdownOpen]);

  const onItemChecked = (checked, id) => {
    let checkeds = [...itemsChecked];
    if (checked) {
      checkeds.push(id);
    } else {
      checkeds = checkeds.filter((i) => i !== id);
    }
    setItemsChecked(checkeds);
    const newValue = checkeds
      .map((i) => {
        const item = dropdownItems.find((ii) => (ii.id || ii._id) === i);
        return item.name;
      })
      .join(', ');
    if (!frozenValue) {
      setStateValue(newValue);
    }
    checkOnChange(checkeds);
  };

  const onInputChanged = (value) => {
    if (!frozenValue) {
      setStateValue(value.name);
    }

    if (useSearch) {
      if (_.has(value, 'name')) {
        const newValue = _.has(value, 'fantasyName')
          ? value.name.substr(0, value.name.indexOf(' -'))
          : value.name;
        setStateValue(newValue);
      } else {
        setStateValue(value);
      }
    } else {
      setDropdownOpen(false);
    }

    checkOnChange(value || '');
  };

  const checkOnChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const handleClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const removeModSelect = (event) => {
    if (selectMod.current && !selectMod.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const classes = [
    `form-group bs-input-dropdown${darkMode ? '-dark' : ''}`,
    className,
  ].join(' ');

  const getInputValue = () => {
    if (!Array.isArray(dropdownItems) || !Array.isArray(dropdownItemsChecked)) {
      return stateValue;
    }
    const hasAll = dropdownItems.find((item) =>
      dropdownItemsChecked.find(
        (ch) => item._id === ch && item.name === 'Todos'
      )
    );

    return hasAll ? 'Todos' : stateValue;
  };

  const getInputItemsList = () => {
    return useSearch ? filteredDropdownItemsList : dropdownItems;
  };

  const renderInputHtmlElements = () => {
    if (useSearch) {
      return (
        <>
          <input
            className={`form-control ${
              darkMode && dropdownOpen ? 'dark-active' : ''
            } ${disabled ? 'disabled-input' : ''}`}
            type="text"
            onFocus={handleClick}
            onChange={(e) => onInputChanged(e.target.value)}
            value={getInputValue() || ''}
            placeholder={placeholder || ''}
            style={{ width: styleWidth }}
          />
        </>
      );
    }

    return (
      <>
        <input
          className={`form-control ${
            darkMode && dropdownOpen ? 'dark-active' : ''
          } ${disabled ? 'disabled-input' : ''}`}
          type="text"
          onChange={(e) => onInputChanged(e.target.value)}
          value={getInputValue() || ''}
          placeholder={placeholder || ''}
          style={{ width: styleWidth }}
        />
        <button
          className={disabled ? 'disabled-btn' : ''}
          type="button"
          onClick={handleClick}
          disabled={disabled}
        />
      </>
    );
  };

  return (
    <div className={classes} ref={selectMod} hidden={props.hidden || false}>
      <label hidden={!label}>{label || ''}</label>
      {renderInputHtmlElements()}
      {darkMode && dropdownOpen ? null : (
        <img src={dropdownIcon} onClick={handleClick} alt="" />
      )}
      <div
        className="bs-input-dropdown-list"
        style={{ width: styleWidth }}
        id="ipt-modal"
        hidden={!dropdownOpen}
      >
        {getInputItemsList().length !== 0 ? (
          getInputItemsList().map((item) => {
            if (useCheckbox) {
              return (
                <div key={`${item?._id}-${item?.name}`} title={item.name}>
                  <Checkbox
                    label={item.name}
                    type={item.id || item._id}
                    checked={
                      itemsChecked
                        ? itemsChecked.find(
                            (i) => i === (item.id || item._id)
                          ) !== undefined
                        : undefined
                    }
                    onChange={(e, type) =>
                      onItemChecked(e.target.checked, type)
                    }
                  />
                </div>
              );
            }
            return (
              <div
                id={item?._id}
                key={`${item?._id}-${item?.name}`}
                title={item.name}
                onClick={() => {
                  if (useSearch) {
                    setStateValue(item?.name || '');
                    setDropdownOpen(false);
                  }
                  onInputChanged(item);
                }}
              >
                {item.name}
              </div>
            );
          })
        ) : (
          <span className="input-dropdown-no-items">{messageNoItems}</span>
        )}
      </div>
    </div>
  );
};
